import { ListItemDecorator, Tab, tabClasses, TabList, TabPanel, Tabs, Skeleton, Box } from "@mui/joy";

interface INavigationTabs {
    tabList: ITabList[];
    loading?: boolean;
}

interface ITabList {
    name: string;
    icon: any;
    component: any;
}

export function NavigationTabs(props: INavigationTabs) {
    const { tabList, loading } = { ...props };
    return (
        <Tabs defaultValue={tabList[0].name} size="sm" sx={{ mt: 0, width: "100%" }}>
            <TabList
                sx={{
                    gap: 2,
                    position: "sticky",
                    bgcolor: "background.surface",
                    zIndex: 1001,
                    top: 0,
                    [`&& .${tabClasses.root}`]: {
                        flex: "initial",
                        color: "text.secondary",
                        opacity: 0.7,
                        background: "transparent",
                        bgcolor: "transparent",
                        paddingLeft: 0.5,
                        paddingRight: 0.5,
                        paddingBottom: 1.5,
                        paddingTop: 1.5,
                        fontWeight: 600,
                        "&:hover": {
                            bgcolor: "transparent",
                        },
                        [`&.${tabClasses.selected}`]: {
                            color: "primary.plainColor",
                            fontWeight: 600,
                            opacity: 1,
                            "&::after": {
                                height: 2,
                                borderTopLeftRadius: 3,
                                borderTopRightRadius: 3,
                                bgcolor: "primary.500",
                            },
                        },
                    },
                }}
            >
                {tabList.map((tab: ITabList, index: number) => {
                    return (
                        <Tab sx={{ ml: index === 0 ? 2 : 0 }} key={tab.name} value={tab.name}>
                            <Skeleton loading={loading} variant="text" width={80}>
                                <ListItemDecorator>{tab.icon}</ListItemDecorator>
                                {tab.name}
                            </Skeleton>
                        </Tab>
                    );
                })}
            </TabList>
            {tabList.map((tab: ITabList) => {
                return (
                    <TabPanel key={tab.name} value={tab.name} sx={{ p: 2 }}>
                        {tab.component}
                    </TabPanel>
                );
            })}
        </Tabs>
    );
}
